import React from 'react';
import { useDispatch } from 'react-redux';
import { setDiningOption } from '../../store/orderSlice';
import Button from '../ui/Button';
import Card from '../ui/Card';

const DiningSelectionScreen: React.FC = () => {
  const dispatch = useDispatch();

  const handleDiningOption = (option: 'eat-in' | 'takeaway') => {
    dispatch(setDiningOption(option));
  };

  return (
    <div className="min-h-screen bg-kiosk-bg flex flex-col items-center justify-center p-kiosk-margin">
      <div className="text-center mb-16">
        <h1 className="text-kiosk-6xl font-bold text-kiosk-text mb-6">
          Where would you like to eat?
        </h1>
        <p className="text-kiosk-2xl text-kiosk-text-light">
          Please select your dining preference
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-kiosk-margin max-w-6xl w-full">
        <Card 
          hoverable 
          onClick={() => handleDiningOption('eat-in')}
          className="p-12 text-center cursor-pointer"
        >
          <div className="text-8xl mb-6">🍽️</div>
          <h3 className="text-kiosk-4xl font-semibold text-kiosk-text mb-6">Eat In</h3>
          <p className="text-kiosk-xl text-kiosk-text-light mb-8">
            Enjoy your meal in our restaurant
          </p>
          <Button variant="primary" size="lg" className="w-full">
            Dine In
          </Button>
        </Card>

        <Card 
          hoverable 
          onClick={() => handleDiningOption('takeaway')}
          className="p-12 text-center cursor-pointer"
        >
          <div className="text-8xl mb-6">🥡</div>
          <h3 className="text-kiosk-4xl font-semibold text-kiosk-text mb-6">Take Away</h3>
          <p className="text-kiosk-xl text-kiosk-text-light mb-8">
            Take your order to go
          </p>
          <Button variant="primary" size="lg" className="w-full">
            Take Away
          </Button>
        </Card>
      </div>

      <div className="mt-16">
        <Button 
          variant="outline" 
          onClick={() => window.location.reload()}
          className="px-12"
        >
          Back to Start
        </Button>
      </div>
    </div>
  );
};

export default DiningSelectionScreen; 